import { createRouter, createWebHistory } from 'vue-router'
import Dashboard from '../views/dashboard/Index.vue'
import Login from '../views/auth/Login.vue'
// Simula una función que verifica si el usuario está autenticado
// En una implementación real, podrías verificar un token en localStorage o Vuex
const isAuthenticated = () => {
  return localStorage.getItem('userToken') !== null; // Verifica si hay un token almacenado
};

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      requiresAuth: false, // No necesita autenticación
    },
  },
  {
    path: '/',
    component: Dashboard,
    children:[
      {
        path: "", // Redirección predeterminada para /dashboard
        redirect: "dashboard",
      },
      {
        path: "dashboard", // Ruta accesible en /dashboard/agenda
        name: "CorporateAgenda",
        component: () => import("../views/corporate-agenda/Index.vue"),
      },
      {
        path: "companies", // Ruta accesible en /dashboard/agenda
        name: "Companies",
        component: () => import("../views/companies/Index.vue"),
      },
      {
        path: "centers", // Ruta accesible en /dashboard/agenda
        name: "Centers",
        component: () => import("../views/centers/Index.vue"),
      },
      {
        path: "departments", // Ruta accesible en /dashboard/agenda
        name: "Departments",
        component: () => import("../views/departments/Index.vue"),
      },
      {
        path: "users", // Ruta accesible en /dashboard/agenda
        name: "Users",
        component: () => import("../views/users/Index.vue"),
      },




    ],
    meta: {
      requiresAuth: true, // Requiere autenticación
    },
  },
  // {
  //   path: "/:pathMatch(.*)*", // Ruta para manejar páginas no encontradas
  //   redirect: "/login",
  // },
];

const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_BASE_URL),
  routes,
});

// Guarda de navegación global
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (requiresAuth && !isAuthenticated()) {
    // Si la ruta requiere autenticación y el usuario no está autenticado
    next('/login'); // Redirigir a login
  } else if (!requiresAuth && isAuthenticated() && to.name === 'Login') {
    // Si el usuario está autenticado e intenta ir a login, redirigir al dashboard
    next('/');
  } else {
    // De lo contrario, permite la navegación
    next();
  }
});

export default router;
